import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { CreateClientView } from '../components/websiteClaims/views/createClientView'

function CreateClient() {
    return (
        <div className="create-client">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader title="Add New Client" backTo="/media-claims" backLabel="Back to clients" />
                    <CreateClientView />
                </Page>
            </MainView>
        </div>
    )
}

export default CreateClient
